import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";

const Getters: GetterTree<any, any> = {
  [types.GETTER_VALID_USER_STATUS](state, getters, rootState) {
    const reliableUser = getters[types.GETTER_LOGIN_FIRST_USER];
    if (!reliableUser) {
      return false;
    } else {
      const findUser = state.userStatusList.find((user: any) => {
        return user.userId === reliableUser.userId;
      });
      return findUser;
    }
  },
  [types.GETTER_USER_STATUS_BY_ID](state, getters, rootState) {
    return (userId: number) => {
      const findUser = state.userStatusList.find((user: any) => {
        return user.userId === userId;
      });
      return findUser;
    };
  },
  [types.GETTER_USER_STATUS_LIST](state, getters, rootState) {
    return state.userStatusList;
  }
};

export default Getters;
